// client/src/core/game/QuestionManager.js
window.QuestionManager = {
    /**
     * Kategoriden soruları çeker ve 'Görülmüş Soru' (History) mantığına göre süzer.
     * ÖNCELİK: Teable API → Başarısızsa yerel fallback.
     * @param {string} category - Kategori anahtarı (tarih, cografya vb.)
     * @param {string} modeKey - Zorluk seviyesi (kolay, orta, zor)
     * @returns {Promise<Array>} - Seçilen 10 soruluk liste
     */
    selectQuestions: async function (category, modeKey) {
        let allQuestions = [];

        // 1. API'den çekmeyi dene
        if (window.TeableQuestionService) {
            try {
                allQuestions = await window.TeableQuestionService.fetchQuestions(category, modeKey);
            } catch (e) {
                console.warn('[QuestionManager] API çağrısı başarısız, fallback...', e);
            }
        }

        // 2. Fallback: yerel veri
        if (!allQuestions || allQuestions.length === 0) {
            console.log('[QuestionManager] Yerel veriden yükleniyor...');
            const allQuestionsData = window.questionsData;
            const categoryData = allQuestionsData ? allQuestionsData[category] : null;

            if (!categoryData || !categoryData[modeKey]) {
                console.error("Soru bulunamadı:", category, modeKey);
                return [];
            }
            allQuestions = [...categoryData[modeKey]];
        } else {
            // API'den gelen verileri kopyala
            allQuestions = [...allQuestions];
        }

        // 3. Geçmişi (Görülen Soruları) Yükle
        const historyKey = `gaddar_seen_${category}_${modeKey}`;
        let seenIds = this.getSeenIds(historyKey);

        // 4. Havuzdaki 'Görülmemiş' Soruları Bul
        let unseenQuestions = allQuestions.filter(q => !seenIds.includes(q.id));

        // HEDEF: 10 Soru
        let selectedQuestions = [];
        const NEEDED_COUNT = 10;

        // 5. Seçim Mantığı
        if (unseenQuestions.length >= NEEDED_COUNT) {
            const shuffledUnseen = window.utils.shuffleArray(unseenQuestions);
            selectedQuestions = shuffledUnseen.slice(0, NEEDED_COUNT);

        } else {
            console.log(`[QuestionManager] Havuz tükendi veya azaldı (${category}-${modeKey}). Tarihçe sıfırlanıyor...`);

            selectedQuestions.push(...unseenQuestions);

            seenIds = [];
            this.clearSeenIds(historyKey);

            const neededMore = NEEDED_COUNT - selectedQuestions.length;
            const currentSelectedIds = selectedQuestions.map(q => q.id);
            const freshPool = allQuestions.filter(q => !currentSelectedIds.includes(q.id));
            const shuffledFresh = window.utils.shuffleArray(freshPool);
            const extraQuestions = shuffledFresh.slice(0, neededMore);
            selectedQuestions.push(...extraQuestions);
        }

        // 6. Seçilenleri Geçmişe Kaydet
        const newSeenIds = selectedQuestions.map(q => q.id);
        const combinedSeen = [...new Set([...seenIds, ...newSeenIds])];
        this.saveSeenIds(historyKey, combinedSeen);

        // 7. Son Karıştırma
        return window.utils.shuffleArray(selectedQuestions);
    },

    /**
     * LocalStorage'dan geçmişi okur.
     */
    getSeenIds: function (key) {
        try {
            const data = localStorage.getItem(key);
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.warn("LocalStorage okuma hatası:", e);
            return [];
        }
    },

    /**
     * LocalStorage'a geçmişi yazar.
     */
    saveSeenIds: function (key, ids) {
        try {
            localStorage.setItem(key, JSON.stringify(ids));
        } catch (e) {
            console.warn("LocalStorage yazma hatası:", e);
        }
    },

    /**
     * Geçmişi temizler.
     */
    clearSeenIds: function (key) {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            console.warn("LocalStorage silme hatası:", e);
        }
    },

    /**
     * Şıkları karıştırır ve gerekirse 5 şıktan 4'e düşürür.
     * @param {Object} question - Soru objesi
     */
    prepareQuestionOptions: function (question) {
        if (question.options.length > 4) {
            const correctOptionIndex = question.correct;
            let newOptions = [...question.options];

            if (correctOptionIndex === 4) {
                newOptions.splice(3, 1);
                question.correct = 3;
            } else {
                newOptions.splice(4, 1);
            }
            question.options = newOptions;
        }
    }
};
